export default __webpack_public_path__ + "static/media/sort-up.c4ab62b9.svg";